import { type HTMLAttributes } from 'react'
import { cn } from '@/lib/utils/cn'

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: 'primary' | 'success' | 'warning' | 'error' | 'gray' | 'info' | 'default' | 'destructive'
  size?: 'sm' | 'md'
}

const variants = {
  primary: 'bg-primary-100 text-primary-700 dark:bg-primary-900/40 dark:text-primary-200',
  success: 'bg-success-50 text-success-600 dark:bg-success-900/30 dark:text-success-300',
  warning: 'bg-warning-50 text-warning-600 dark:bg-warning-900/30 dark:text-warning-300',
  error: 'bg-error-50 text-error-600 dark:bg-error-900/30 dark:text-error-300',
  gray: 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300',
  // Aliases for legacy callsites
  info: 'bg-primary-100 text-primary-700 dark:bg-primary-900/40 dark:text-primary-200',
  default: 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300',
  destructive: 'bg-error-50 text-error-600 dark:bg-error-900/30 dark:text-error-300',
}

const sizes = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-0.5 text-sm',
}

export function Badge({
  className,
  variant = 'gray',
  size = 'sm',
  children,
  ...props
}: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full font-medium',
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    >
      {children}
    </span>
  )
}
